import type { ReactNode } from 'react';

export const symbol_masked_transitions_add: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M330-230v-100H230v-60h100v-100h60v100h100v60H390v100h-60Zm-167.5 67.5Q80-245 80-360t82.5-197.5Q245-640 360-640t197.5 82.5Q640-475 640-360t-82.5 197.5Q475-80 360-80t-197.5-82.5Zm353-42Q580-269 580-360t-64.5-155.5Q451-580 360-580t-155.5 64.5Q140-451 140-360t64.5 155.5Q269-140 360-140t155.5-64.5ZM668-328q1-7 1.5-15.5t.5-16.5q0-127-91.5-218.5T360-670q-8 0-16 .5t-15 1.5q22-90 98-151t173-61q115 0 197.5 82.5T880-600q0 97-60.5 172.5T668-328Z"
		/>
	</svg>
);
